/**
 * Traditional Chinese (Taiwan) strings.  This file is the source of truth for
 * the message catalogue: `MessageKey` is derived from it, so every other
 * locale has to supply exactly these keys or the build fails.
 *
 * Placeholders are `{name}` and are substituted by `t()` in ./index.tsx.
 */
export const zhTW = {
  'app.name': 'JournalMap',
  'app.subtitle': '書目計量映射',
  'footer.institution': '國立清華大學　教育與學習科技學系',
  'footer.advisor': '指導教授　陳美如 教授',
  'footer.author': '陳奕安 博士候選人　製作',
  'app.skipToContent': '跳到主要內容',

  'nav.new': '新增分析',
  'nav.saved': '我的地圖',

  'header.signIn': '以 Google 登入',
  'header.signOut': '登出',
  'header.signingIn': '登入中',
  'header.signInFailed': '登入沒有成功：{message}',
  'header.quotaLabel': '額度',
  'header.quotaValue': '剩 {remaining} / {limit}',
  'header.quotaResets': '{time} 重設',
  'header.quotaLoading': '讀取中',
  'header.quotaFailed': '讀不到',
  'header.quotaTooltip': '這個週期還可以執行 {remaining} 次分析，共 {limit} 次，{time} 重設。',
  'header.themeLabel': '外觀',
  'header.theme.system': '跟隨系統',
  'header.theme.light': '亮色',
  'header.theme.dark': '暗色',
  'header.localeLabel': '語言',

  'common.retry': '再試一次',
  'common.cancel': '取消',
  'common.close': '關閉',
  'common.copy': '複製連結',
  'common.copied': '已複製',
  'common.loading': '載入中',
  'common.optional': '選填',
  'common.unlimited': '不限',
  'common.on': '開',
  'common.off': '關',
  'common.showAdvanced': '顯示進階設定',
  'common.hideAdvanced': '收起進階設定',
  'common.back': '回上一頁',
  'common.delete': '刪除',
  'common.open': '開啟',
  'common.seconds': '{n} 秒',
  'common.dash': '—',

  'home.title': '建立一張地圖',
  'home.lead': '先選資料來源，再選要做哪一種分析。參數的預設值與 VOSviewer 相同。',
  'home.step1': '一、資料來源',
  'home.step2': '二、分析與參數',
  'home.step3': '三、執行',
  'home.run': '執行分析',
  'home.runNoSource': '先選一個資料來源。',
  'home.runNoAuth': '執行分析要先登入。看別人分享的地圖不用。',
  'home.runNoQuota': '這個週期的 {limit} 次額度已經用完，{resets} 重設。',
  'home.capTitle': '公開服務的規模上限',
  'home.capBody': '一次分析最多 {docs} 篇文獻、{items} 個地圖項目。',
  'home.capUpload': '上傳的匯出檔單檔上限 {size}。',
  'home.capWhy': 'VOS 佈局的排斥力要算過所有節點配對，每回合是 O(n²)，而且要跑一千回合。這個上限讓一次分析停在一分鐘以內，API 才能同步回應。要跑更大的資料，得改成 Cloud Tasks 佇列加背景工作服務。',

  'source.tab.openalex': 'OpenAlex 查詢',
  'source.tab.upload': '上傳匯出檔',
  'source.openalex.hint': '直接向 OpenAlex 取資料。執行前會先算出會抓到幾篇。',
  'source.upload.hint': 'Web of Science、Scopus、RIS 或 PubMed 的匯出檔，格式自動判斷。',

  'query.search.label': '檢索詞',
  'query.search.hint': '比對標題、摘要與全文；多個詞要全部命中才算。',
  'query.search.placeholder': 'perovskite solar cell',
  'query.yearFrom.label': '起始年',
  'query.yearTo.label': '結束年',
  'query.year.hint': '依出版年份篩選，兩端都含在內。留空表示不限。',
  'query.venue.label': '期刊或會議',
  'query.venue.hint': '來源名稱的關鍵字，例如 Scientometrics。',
  'query.venue.placeholder': 'Scientometrics',
  'query.openAccess.label': '只要開放取用',
  'query.openAccess.hint': '限定 OpenAlex 標為 open access 的文獻。',
  'query.institution.label': '機構',
  'query.institution.hint': '作者所屬機構名稱的關鍵字。',
  'query.institution.placeholder': 'National Tsing Hua University',
  'query.country.label': '國家或地區',
  'query.country.hint': '作者機構所在地的兩碼國碼，例如 TW、US、JP。',
  'query.country.placeholder': 'TW',
  'query.filter.label': '額外篩選',
  'query.filter.hint': 'OpenAlex 原生的 filter 語法，用逗號分隔，會與上面的欄位合併。',
  'query.filter.placeholder': 'type:article,has_doi:true',
  'query.maxResults.label': '最多取幾篇',
  'query.maxResults.hint': '從符合條件的文獻中依相關度取前幾篇。上限 {cap} 篇。',

  'count.idle': '填好條件後會顯示筆數。',
  'count.loading': '計算筆數中',
  'count.result': '符合 {count} 篇',
  'count.capped': '符合 {count} 篇，只會取前 {cap} 篇',
  'count.zero': '沒有符合的文獻。放寬年份或換個檢索詞。',
  'count.error': '筆數查不到：{message}',
  'count.refresh': '重新計算',

  'upload.drop': '把檔案拖進來，或點一下挑檔',
  'upload.dropActive': '放開就會讀入',
  'upload.formats': '支援 WoS 純文字、Scopus CSV、RIS、PubMed nbib。單檔上限 {size}。',
  'upload.choose': '選擇檔案',
  'upload.remove': '移除',
  'upload.tooBig': '這個檔案 {size}，超過 {limit} 的上限。',
  'upload.badType': '副檔名 {ext} 不在支援的清單裡。',

  'analysis.label': '分析類型',
  'analysis.co_authorship': '共同作者',
  'analysis.co_authorship.desc': '兩位作者一起發表過幾篇文獻。也可以改看機構或國家。',
  'analysis.keyword_co_occurrence': '關鍵詞共現',
  'analysis.keyword_co_occurrence.desc': '兩個關鍵詞出現在同一篇文獻的次數。',
  'analysis.terms': '詞彙圖',
  'analysis.terms.desc': '從標題與摘要抽名詞片語，依相關度留下最專指的一批，再看它們的共現。',
  'analysis.citation': '直接引用',
  'analysis.citation.desc': '語料庫內部誰引用誰。參考文獻對不上就會是一張空圖。',
  'analysis.bibliographic_coupling': '書目耦合',
  'analysis.bibliographic_coupling.desc': '兩篇文獻共用了多少參考文獻。參考文獻本身不必在語料庫裡。',
  'analysis.co_citation': '共被引',
  'analysis.co_citation.desc': '兩篇被引文獻被同一批文獻一起引用的次數。',

  'param.unit.label': '分析單位',
  'param.unit.hint.co_authorship': '要把誰當節點：作者本人、他們的機構，或機構所在國家。',
  'param.unit.hint.citation': '節點可以是文獻本身，也可以把引用彙總到作者、期刊、機構或國家。',
  'param.unit.hint.co_citation': '被引的對象是一篇文獻、它的作者，還是它刊登的期刊。',
  'unit.authors': '作者',
  'unit.organizations': '機構',
  'unit.countries': '國家或地區',
  'unit.documents': '文獻',
  'unit.sources': '來源期刊',
  'unit.references': '被引文獻',

  'param.keywordSource.label': '關鍵詞來源',
  'param.keywordSource.hint': '作者關鍵詞來自匯出檔的 DE 欄位，索引關鍵詞是資料庫自己加的 ID 欄位。',
  'keywordSource.author': '作者關鍵詞',
  'keywordSource.index': '索引關鍵詞',
  'keywordSource.both': '兩者都要',

  'param.counting.label': '計數方式',
  'param.counting.hint': '完整計數下每個共現配對算一次。分數計數會把一篇文獻的權重除以它貢獻的配對數，作者名單很長的文獻就不會壓過其他文獻。',
  'counting.full': '完整計數',
  'counting.fractional': '分數計數',

  'param.minOccurrences.label.occurrences': '最少出現次數',
  'param.minOccurrences.label.documents': '最少文獻數',
  'param.minOccurrences.label.citations': '最少被引次數',
  'param.minOccurrences.hint.occurrences': '出現次數低於這個值的項目不會進圖。VOSviewer 的預設是 {default}。',
  'param.minOccurrences.hint.documents': '文獻數低於這個值的項目不會進圖。VOSviewer 的預設是 {default}。',
  'param.minOccurrences.hint.citations': '被引次數低於這個值的參考文獻沒辦法定位，不會進圖。VOSviewer 的預設是 {default}。',

  'param.minCitations.label': '最少被引次數',
  'param.minCitations.hint': '再加一道門檻，只留被引次數達標的項目。0 表示不篩。',
  'param.maxItems.label': '最多項目數',
  'param.maxItems.hint': '門檻過關的項目若超過這個數，只留權重最高的前幾名。上限 {cap}。',

  'param.fields.label': '取詞欄位',
  'param.fields.hint': '要從哪些欄位抽名詞片語。',
  'fields.title': '標題',
  'fields.abstract': '摘要',
  'param.language.label': '語言',
  'param.language.hint': '中文會送到另一個載有 CKIP 模型的服務斷詞，比英文慢一些。',
  'language.english': '英文',
  'language.chinese': '中文',
  'param.binaryCounting.label': '二元計數',
  'param.binaryCounting.hint': '一個詞在同一篇文獻出現多次只算一次。VOSviewer 的預設是開啟。',
  'param.relevanceFraction.label': '相關度保留比例',
  'param.relevanceFraction.hint': '以隨機漫步的 KL 散度衡量一個詞有多專指，只留最專指的一部分。VOSviewer 的預設是 0.60，也就是留 60%。',
  'param.nTerms.label': '詞彙數上限',
  'param.nTerms.hint': '篩選之後再截到這個數量。留空表示不截。',
  'param.cocitationKey.label': '被引文獻的識別方式',
  'param.cocitationKey.hint': '比對鍵會把同一篇文獻的不同寫法併成一個節點。字串是 VOSviewer 的做法，兩種寫法會變成兩個節點。',
  'cocitationKey.matchkey': '比對鍵',
  'cocitationKey.string': '參考文獻字串',

  'adv.title': '進階：正規化、分群與佈局',
  'adv.note': '這些都是 VOSviewer 的預設值。沒有特別理由就不用動。',
  'param.normalization.label': '連結強度正規化',
  'param.normalization.hint': '正規化後的網路會同時餵給佈局與分群；地圖檔裡存的仍是原始強度。',
  'normalization.none': '不正規化',
  'normalization.association': '關聯強度',
  'normalization.fractionalization': '分數化',
  'normalization.linlog': 'LinLog／模組度',
  'param.resolution.label': '分群解析度',
  'param.resolution.hint': '調高群集會變多、變小。VOSviewer 的預設是 1.00。',
  'param.minClusterSize.label': '最小群集大小',
  'param.minClusterSize.hint': '小於這個大小的群集會被併掉。',
  'param.mergeSmallClusters.label': '合併小群集',
  'param.mergeSmallClusters.hint': '關掉的話，小群集會各自留成獨立的群。',
  'param.clusterRandomStarts.label': '分群隨機起始次數',
  'param.clusterRandomStarts.hint': 'Leiden 跑這麼多次，取品質最好的一次。',
  'param.clusterIterations.label': '分群迭代次數',
  'param.clusterIterations.hint': '每次起始最多迭代幾輪。',
  'param.attraction.label': '吸引力',
  'param.repulsion.label': '排斥力',
  'param.attraction.hint': 'VOS 佈局的吸引力指數，預設 2。',
  'param.repulsion.hint': 'VOS 佈局的排斥力指數，預設 1。改這兩個會明顯換一張圖。',
  'param.largestComponent.label': '只留最大連通元件',
  'param.largestComponent.hint': '丟掉與主體不相連的孤島。',
  'param.seed.label': '隨機種子',
  'param.seed.hint': '種子固定才重現得出同一張圖。VOSviewer 的預設是 0。',

  'run.title': '執行中',
  'run.hint': '這一步最久大約一分鐘。離開這個頁面會中止分析。',
  'run.elapsed': '已經 {seconds} 秒',
  'run.cancel': '中止',
  'run.stage.uploading': '上傳檔案',
  'run.stage.queued': '排隊',
  'run.stage.fetching': '取得資料',
  'run.stage.parsing': '解析檔案',
  'run.stage.extracting': '抽取詞彙',
  'run.stage.segmenting': '中文斷詞',
  'run.stage.counting': '計算共現',
  'run.stage.thresholding': '套用門檻',
  'run.stage.normalizing': '正規化',
  'run.stage.layout': 'VOS 佈局',
  'run.stage.clustering': 'Leiden 分群',
  'run.stage.writing': '輸出檔案',
  'run.stage.done': '完成',
  'run.stage.unknown': '處理中',

  'error.title': '這次沒有跑完',
  'error.loadTitle': '這張地圖打不開',
  'error.whatNow': '可以改的地方',
  'error.quota_exceeded': '這個週期的 {limit} 次額度已經用完，{resets} 重設。',
  'error.rate_limited': '短時間內送出太多次。等 {seconds} 秒再試。',
  'error.too_many_documents': '這批資料有 {actual} 篇，超過 {limit} 篇的上限。縮小年份範圍，或把檢索詞收緊。',
  'error.too_many_items': '門檻過關的項目有 {actual} 個，超過 {limit} 個的上限。把最少出現次數調高，或把最多項目數調低。',
  'error.upload_too_large': '檔案 {actual}，超過 {limit} 的上限。',
  'error.parse_failed': '這個檔案讀不出來：{message}',
  'error.empty_result': '查詢沒有回傳任何文獻。',
  'error.empty_map': '沒有項目通過門檻，地圖是空的。把最少出現次數調低再試。',
  'error.unauthenticated': '這個動作要先登入。',
  'error.forbidden': '你沒有權限看這份資料。',
  'error.not_found': '找不到這份資料。',
  'error.network': '連不上伺服器。檢查網路之後再試一次。',
  'error.timeout': '伺服器太久沒有回應。',
  'error.cancelled': '已經中止。',
  'error.unsupported': '這個部署不支援這項設定：{message}',
  'error.internal': '伺服器出錯：{message}',
  'error.unknown': '沒有預期到的錯誤：{message}',
  'error.notConfigured': '這個部署還沒有設定 {name}。請在建置環境補上再重新部署。',

  'result.backToHome': '再做一張',
  'result.loading': '載入地圖中',
  'result.meta.items': '{n} 個項目',
  'result.meta.links': '{n} 條連結',
  'result.meta.clusters': '{n} 個群集',
  'result.meta.docs': '{n} 篇文獻',
  'result.view.label': '檢視',
  'result.view.network': '網路',
  'result.view.overlay': '疊加',
  'result.view.density': '項目密度',
  'result.view.clusterDensity': '群集密度',
  'result.overlay.label': '疊加數值',
  'result.weight.label': '節點大小',
  'result.linkDensity.label': '連結密度',
  'result.linkDensity.hint': '只畫強度最高的一部分連結。連結太多的時候調低會好讀很多。',
  'result.linkDensity.value': '{percent}%，{shown} / {total} 條',
  'result.legend.title': '群集',
  'result.legend.cluster': '群集 {n}',
  'result.legend.count': '{n} 個項目',
  'result.legend.none': '這張地圖沒有群集資訊。',
  'result.detail.title': '項目',
  'result.detail.empty': '在地圖上點一個項目，這裡會顯示它的數值。',
  'result.detail.cluster': '群集',
  'result.detail.weights': '權重',
  'result.detail.scores': '分數',
  'result.detail.neighbours': '連結最強的鄰居',
  'result.detail.noNeighbours': '這個項目沒有連結。',
  'result.detail.openUrl': '開啟原始連結',
  'result.detail.coordinates': '座標',
  'result.export.label': '匯出',
  'result.export.json': 'VOSviewer JSON',
  'result.export.map': '地圖檔',
  'result.export.network': '網路檔',
  'result.export.png': 'PNG 影像',
  'result.export.hint': 'JSON 可以直接丟到 VOSviewer Online。地圖檔與網路檔用桌面版的 File 選單開。',
  'result.export.failed': '匯出失敗：{message}',
  'result.export.working': '匯出中',
  'result.warnings.title': '這張地圖的提醒',
  'result.build.title': '建置摘要',
  'result.build.counted': '計數項目',
  'result.build.dropped': '被門檻濾掉',
  'result.build.quality': '分群品質',
  'result.build.duration': '耗時',
  'result.search.placeholder': '在地圖中找項目',
  'result.search.noMatch': '沒有相符的項目。',
  'result.panel.hide': '收起側欄',
  'result.panel.show': '展開側欄',

  'saved.title': '我的地圖',
  'saved.lead': '每次執行成功的分析都會存在這裡。',
  'saved.needAuth': '登入之後才看得到自己的地圖。',
  'saved.empty': '還沒有存過地圖。跑一次分析就會出現在這裡。',
  'saved.loading': '讀取清單中',
  'saved.failed': '清單讀不到：{message}',
  'saved.col.name': '名稱',
  'saved.col.analysis': '分析',
  'saved.col.size': '規模',
  'saved.col.created': '建立時間',
  'saved.col.share': '公開分享',
  'saved.deleteConfirm': '要刪掉「{name}」嗎？這個動作沒辦法復原。',
  'saved.deleteFailed': '刪不掉：{message}',
  'saved.share.on': '已公開',
  'saved.share.off': '未公開',
  'saved.share.hint': '開啟之後，任何拿到連結的人都看得到這張地圖，不需要登入。',
  'saved.share.failed': '分享設定改不了：{message}',
  'saved.share.link': '公開連結',

  'public.badge': '公開分享的地圖',
  'public.meta': '{analysis}・{items} 個項目・{date}',
  'public.notFound': '這個連結沒有對應的地圖，也可能已經取消分享。',
  'public.cta': '你也可以做一張',

  'notFound.title': '沒有這個頁面',
  'notFound.body': '網址可能打錯了，或是這個頁面已經移走。',
  'notFound.home': '回到首頁',

  'crash.title': '介面出錯了',
  'crash.body': '這是前端的錯，不是你的操作有問題。重新整理通常就會好。',
  'crash.reload': '重新整理',
} as const;

export type MessageKey = keyof typeof zhTW;
export type Messages = Record<MessageKey, string>;
